import React from "react";
import { cn } from "@/lib/utils";

/**
 * BrandMark - Compact square logo mark (gear + 360).
 * Uses the top-portion of the official Prosper360 logo image so that
 * the mark reads cleanly at small sizes (sidebar, avatars, cards).
 *
 * The image is served from /prosper360-logo.png (public folder).
 */
export function BrandMark({ size = 36, className = "", rounded = "rounded-lg" }) {
    return (
        <div
            className={cn(
                "grid place-items-center overflow-hidden bg-brand-navy shadow-sm ring-1 ring-black/10",
                rounded,
                className,
            )}
            style={{ width: size, height: size, flex: `0 0 ${size}px` }}
            aria-hidden
        >
            <img
                src="/prosper360-logo.png"
                alt=""
                className="h-full w-full object-cover"
                style={{ objectPosition: "center 30%", transform: "scale(1.55)" }}
                draggable="false"
            />
        </div>
    );
}

/**
 * BrandFullLogo - Full logo (gear + text "PROSPER 360 ENGENHARIA INTEGRADA").
 * Renders the entire image without cropping. Ideal for splash/login/public pages.
 */
export function BrandFullLogo({ className = "", size = 240 }) {
    return (
        <img
            src="/prosper360-logo.png"
            alt="Prosper360 · Engenharia Integrada"
            className={cn("select-none rounded-2xl shadow-xl", className)}
            style={{ width: size, height: size, objectFit: "contain" }}
            draggable="false"
        />
    );
}

/**
 * BrandInline - Logo mark next to text.
 * Used in the sidebar header + login secondary spots.
 */
export function BrandInline({ subtitle = "Engenharia Integrada", size = 36 }) {
    return (
        <div className="flex items-center gap-3">
            <BrandMark size={size} />
            <div className="flex flex-col leading-tight">
                <span className="text-sm font-semibold tracking-tight">Prosper360</span>
                <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
                    {subtitle}
                </span>
            </div>
        </div>
    );
}
